module.exports = __webpack_public_path__ + "images/9e332e663774c528ac4d48c4b1aef831-donuts.png";